import moment from "moment/moment";
import { DEFAULT_DATE_FORMAT, DEFAULT_TIME_FORMAT } from "../../helpers/constants";
import { convertToUserTimezone } from "../../helpers/Utils";

export const isValidDate = (year, month, day) => {
  const inputDate = moment(`${year}-${month}-${day}`, "YYYY-MM-DD", true);
  const today = moment().startOf("day");
  return inputDate.isValid() && !inputDate.isAfter(today);
};

export function formatTimeFromUTC(value) {
  if (!value) return "";
  value = value.replace(" ", "T") + "Z";
  const date = new Date(value.replace(" ", "T") + "Z");
  if (isNaN(date.getTime())) {
    console.warn("Invalid date:", value);
    return "";
  }
  return convertToUserTimezone(value,DEFAULT_TIME_FORMAT)
}
export function formatDateAndTimeFromUTC(value) {
  if (!value) return { date: "", time: "" };
  value = value.replace(" ", "T") + "Z";  
  return {
    date: convertToUserTimezone(value, DEFAULT_DATE_FORMAT),
    time: convertToUserTimezone(value, DEFAULT_TIME_FORMAT),
    dateTime: convertToUserTimezone(value),
  };
}
export const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return { dateTime: "", date: "", time: "" };

  const [date, timeWithMs] = dateTimeString.split(" ");

  if (!timeWithMs) {
    return { dateTime: date, date, time: "" }; // Return only the date if no time is provided
  }

  const [hour, minute] = timeWithMs.split(".")[0].split(":");
  const hours = hour % 12 || 12;
  const period = hour >= 12 ? "PM" : "AM";

  return {
    dateTime: `${date} / ${hours}:${minute} ${period}`,
    date,
    time: `${hours}:${minute} ${period}`,
  };
};

export const formatDateTimeModal = (isoString) => {
  if (!isoString) return "";
  const [date, time] = isoString?.split(" ");
  const formattedTime = time?.split(" ")[0];
  return `${date} ${formattedTime}`;
};
export const getCurrentTime = () => {
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  };
  return new Date().toLocaleString("en-US", options);
};
export const getCurrentTimeWithSeconds = () => {
  const options = {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };
  return new Date().toLocaleString("en-US", options);
};

export const getCurrentDateTimeWithSeconds = () => {
  const now = new Date();

  const date = now.toLocaleDateString("en-CA"); // Format: YYYY-MM-DD
  const time = now.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

  return `${date} ${time}`;
};

export const makeRoundOff = (val) => {
  const num = parseFloat(val);
  if (isNaN(num)) return 0;
  return Math.round(num);
};


export const  formatToDateTimeLocal = () => {
  const date = new Date();

  const pad = (n) => String(n).padStart(2, '0'); // Pad single digits with 0

  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1); // Months are zero-indexed
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}


export const newIncreasingDate = (increasedDuration , defaultTime) => {
  const baseDate = new Date(defaultTime);

  if (isNaN(baseDate.getTime())) {
    throw new Error("Invalid defaultTime provided");
  }

  baseDate.setMinutes(baseDate.getMinutes() + increasedDuration);

  const pad = (num) => String(num).padStart(2, '0');

  const year = baseDate.getFullYear();
  const month = pad(baseDate.getMonth() + 1); // months are zero-indexed
  const day = pad(baseDate.getDate());
  const hours = pad(baseDate.getHours());
  const minutes = pad(baseDate.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}`;
}

export const getMyTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

export const formatDateTimeNew = (rawDate , format) => {
  return moment(rawDate).format(format);

}